import { Component, Input, ViewChild, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { BaseChartDirective } from 'ng2-charts';
import { ChartConfiguration, ChartType, ActiveElement, ChartEvent } from 'chart.js';

// Define the CustomDataPoint interface
export interface CustomDataPoint {
  custom_property_name_1: string; // "Number of children missing immunisations"
  custom_property_value_1: number; //Number of children missing immunisations
  custom_property_name_2: string; // "Age group"
  custom_property_value_2: string; //"Age group"
  custom_property_name_3: string; //"Total children registered"
  custom_property_value_3: number; // Total children registered
  custom_property_name_4: string; //"Link"
  custom_property_value_4: string; // the link
  filtered_total_text: string; //this is to hold the label for the total number of records that matched the search query
  filtered_total_value: string; //this is to hold the actual number of records that matched the search query
}
@Component({
  selector: 'app-chart',
  standalone: true,
  template: `
    <div class="chart-container">
      <canvas
        #chartCanvas
        baseChart
        [data]="chartData"
        [type]="chartType"
        [options]="chartOptions"
        [datasets]="chartData.datasets"
        [labels]="chartData.labels"
        (chartClick)="handleChartClick($event)"
      >
      </canvas>
    </div>
  `,
  styleUrls: ['./chart.component.css'],
  imports: [BaseChartDirective], // Import BaseChartDirective for standalone components
})
export class ChartComponent implements OnDestroy {
  @ViewChild(BaseChartDirective) chart: BaseChartDirective | undefined;

  // Inputs for dynamic configuration
  @Input() chartType: ChartType = 'bar';
  @Input() chartData: ChartConfiguration['data'] = {
    labels: [],
    datasets: [],
  };
  @Input() chartOptions: ChartConfiguration['options'] = {};
  @Input() customData: CustomDataPoint[][] = [];

  // Output for click events
  @Output() chartClick = new EventEmitter<CustomDataPoint | null>();

  constructor(private router: Router) {}

  ngOnDestroy(): void {
    this.removeTooltips();
  }

  handleChartClick(event: { event?: ChartEvent; active?: object[] }): void {
    const activeElements = (event.active || []) as ActiveElement[];

    if (activeElements.length > 0) {
      const element = activeElements[0];
      const datasetIndex = element.datasetIndex;
      const dataIndex = element.index;

      // Ensure that customData exists for the selected index and return null if not.
      const dataPoint = this.customData?.[datasetIndex]?.[dataIndex] ?? null;

      // Emit the data point or null based on the presence of data
      if (dataPoint) {
        this.chartClick.emit(dataPoint); // Emit the valid data point
        if (dataPoint.custom_property_value_4) {
          //window.open(dataPoint.custom_property_value_4, '_blank');
          this.router.navigateByUrl(dataPoint.custom_property_value_4).then();
        }
      } else {
        this.chartClick.emit(null); // Emit null when no valid data point exists
      }
    } else {
      this.chartClick.emit(null); // Emit null if no active elements were clicked
    }
    // Remove tooltips when the chart is clicked
    this.removeTooltips();
  }
  private removeTooltips(): void {
    // Remove all tooltip elements with the class 'tooltip'
    const tooltips = document.querySelectorAll('.tooltip');
    tooltips.forEach((tooltip) => {
      if (tooltip.parentNode) {
        tooltip.parentNode.removeChild(tooltip);
      }
    });
  }
}
//TEST COMMENT BY KJ
